<div *ngIf="videoUrl" class="embedded-video">
	<div
		*ngIf="!isPlaying"
		class="embedded-video__placeholder"
		(click)="handleClickPlay()"
	>
		<img
			class="embedded-video__placeholder__thumbnail"
			alt="Video Thumbnail - Click to play"
			src="../../../assets/images/video-placeholder.png"
		/>
		<div class="embedded-video__play-overlay">
			<div class="embedded-video__play-button">
				<svg xmlns="http://www.w3.org/2000/svg" class="embedded-video__play-icon" viewBox="0 0 100 100">
					<path
						d="M 218.328 108.847 Q 237.034 78.297 255.74 108.847 L 280.68 149.581 Q 299.386 180.131 261.975 180.131 L 212.093 180.131 Q 174.682 180.131 193.388 149.581 Z"
						style="transform-box: fill-box; transform-origin: 50% 50%;"
						fill="#FFFFFF"
						transform="matrix(0, 1, -1, -0.002496, -185.606512, -86.843311)"/>
				</svg>
			</div>
		</div>
	</div>

	<iframe
		*ngIf="isPlaying && embedUrl"
		class="embedded-video__item"
		[src]="embedUrl"
		frameborder="0"
		title="YouTube video player"
		referrerpolicy="strict-origin-when-cross-origin"
		allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
		allowfullscreen
	></iframe>
</div>
